module.exports = __webpack_public_path__ + "static/media/seccondgray.82d399d6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/seccondgray.png
 ** module id = 1621
 ** module chunks = 0
 **/